module.exports = __webpack_public_path__ + "1f30db2c5b41eba4e489bc70d1ec1ae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-4.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-4.jpg
// module chunks = 40